export default {
  Billable: 'attach_money',
  'Non-billable Investment': 'business_center',
  'Non-billable Overbuild': 'view_agenda',
  'Non-billable Training': 'fitness_center',
  'Non-billable Infrustructure': 'home',
};
